export default "__VITE_ASSET__boyWfJli__"